import { Button } from '@timelyapp/react';
import { Close } from 'components/Icons';
import Surface from 'components/Surface';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getIsAppInitialized } from 'redux/selectors/global';
import styles from './AuthorizationWrapper.module.scss';

export interface AuthorizationWrapperProps {
  children: React.ReactNode;
  isAuthorized: boolean;
}

const AuthorizationWrapper: React.FC<AuthorizationWrapperProps> = ({ children, isAuthorized }) => {
  const navigate = useNavigate();

  // Show a blank page instead of a flash of "you're not authorized" during initial load.
  const isInitialized = useSelector(getIsAppInitialized);
  if (!isInitialized) return null;

  if (!isAuthorized) {
    return (
      <Surface surface={2} className={styles.root}>
        <Close />
        <p>You're not authorized to view this page.</p>
        <Button
          onClick={() => {
            navigate(-1);
          }}
        >
          Go back
        </Button>
      </Surface>
    );
  }

  return <>{children}</>;
};

export default AuthorizationWrapper;
